import axios from 'axios';

const mine = (data) => axios.get('/custom/figure/mine', data);
const save = (data) => axios.post('/custom/figure/saveOrUpdate', data);
const del = (data) => axios.post('/custom/figure/delete', data); //delete

export default {
  mine,
  save,
  del,
}


